










































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import {ProductEntity} from "@/entity/ProductEntity";
import Id from "@/components/inputs/Id.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Select35 from "@/components/inputs/Select35.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import {categories} from "@/entity/CategoryEntity";
import Seo from "@/components/inputs/Seo.vue";
import SeoText from "@/components/inputs/SeoText.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import {ProductImages} from "@/entity/ProductEntity";
import Editor from '@tinymce/tinymce-vue';
import ProductCategoryListing from "@/components/inputs/ProductCategoryListing.vue";
import ProductImageUpload from "@/views/Product/ProductImageUpload.vue";
import VariantSelector from "@/components/VariantSelector.vue";
import ProductVariantOptionInfo from "@/views/Product/ProductVariantOptionInfo.vue";
import Pages from "@/views/Genel/Pages.vue";
import UrunDetay from "@/views/Product/ProductDetail.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import {SozlesmeEntity} from "@/entity/Sozlesme";
import ProductDetail from "@/views/Product/ProductDetail.vue";


@Component({
  components: {
    ProductDetail,
    UrunDetay,
    Pages,
    ProductVariantOptionInfo,
    VariantSelector,
    ProductImageUpload,
    ProductCategoryListing,
    Decimal,
    EForm, Id, Number, TextField, Select35, ImageUpload, Seo, SeoText, EnabledSwitch, Editor
  }
})
export default class ProductEditNormal extends Vue {
  baseAction: string = ActionsEnum.Product;
  action: string = this.baseAction;
  data: ProductEntity = new ProductEntity();
  categories: categories[] = [];
  productImages: ProductImages[] = [];
  title: string = "Ürün Ekle";
  variations: any[] = [{name:"Varyasyon yok"}];
  detail_enabled:false=false;
  products: ProductEntity[] = [];
  sozlesmeler:SozlesmeEntity[] = [];
  async success() {
    console.log('SUCCESSSSSS!!')
    this.$store.dispatch("go", "/urunayarlari/urunler");
  }

  async get() {
    try {
      if (this.$route.params.product_id == "ekle") {
        this.data = new ProductEntity();
      } else {
        //console.log(this.$route.params.product_id,"dasdsa");
        let response = await this.$http.get(this.baseAction + '/' + this.$route.params.product_id);
        this.data = response.data;
        this.action = this.baseAction + '/' + this.$route.params.product_id
        this.title = this.data.name + " Düzenle";
        this.data.image_origin = this.$store.getters.imagePath + this.data.image_origin;
        this.data.image_show = this.$store.getters.imagePath + this.data.image_show;
        this.data.image_show_thumb = this.$store.getters.imagePath + this.data.image_show_thumb;
        await this.getProductImages();
      }
      await this.getVariations();
    } catch (e) {
      alert(this.$helper.errorHandler(e));
    }
  }

  async getVariations() {
    let response = await this.$http.get("productVariant");
    this.variations = this.variations.concat(response.data);
  }

  async getProductImages() {
    let response = await this.$http.get("productImages/" + this.$route.params.product_id);
    this.productImages = response.data;
  }

  updateCategories(productCategories: any) {
    this.data.product_categories = productCategories;
  }

  async changeSku(value: any) {
    if (value) {
      let response = await this.$http.get("productVariantOptions/" + value);
      this.data.variant_options = response.data;
    }
  }

  async getProducts() {
    let response = await this.$http.get("productMinimal");
    this.products = response.data;
  }
  async getSozlemeler(){
    let response = await this.$http.get(ActionsEnum.Sozlesme);
    this.sozlesmeler = response.data;
  }

  created() {
    this.get();
    this.getProducts();
    this.getSozlemeler();
  }
}
